import { jsx as _jsx } from "react/jsx-runtime";
/*
  Used for map props provided by BaseUi Modal component to props used by Fade component
  https://github.com/mui/base-ui/blob/master/packages/mui-base/src/Modal/Modal.tsx#L176
 */
import { cloneElement, forwardRef } from 'react';
import { Fade } from '@clds/transitions';
export const FadePropsAdapter = 
// eslint-disable-next-line react/display-name
forwardRef(({ in: inProp, timeout, children, onEnter, onExited, ...propsFromBaseUi }, ref) => {
    return (_jsx(Fade, { in: inProp, timeout: timeout, cssTransitionProps: { onEnter, onExited }, children: cloneElement(children, { ...propsFromBaseUi, ref }) }));
});
